var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTargetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4795 7.51562C13.3808 8.75613 12.9281 9.94223 12.1751 10.933C11.4221 11.9238 10.4006 12.6776 9.23177 13.1048C8.063 13.5321 6.79613 13.6149 5.58169 13.3434C4.36725 13.0718 3.25628 12.4574 2.38077 11.573C1.50526 10.6887 0.902011 9.57159 0.642694 8.35448C0.383377 7.13737 0.478891 5.8714 0.91789 4.70698C1.35689 3.54256 2.12092 2.52863 3.11921 1.78565C4.1175 1.04267 5.30808 0.60187 6.54952 0.515625",
    stroke: "#0017E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7905 8.08996C9.60992 8.55476 9.31633 8.96721 8.93628 9.29002C8.55623 9.61283 8.10171 9.83582 7.61382 9.93882C7.12593 10.0418 6.62006 10.0216 6.14196 9.87994C5.66386 9.73829 5.2286 9.47971 4.87555 9.12757C4.52251 8.77543 4.2628 8.34084 4.11993 7.8631C3.97705 7.38537 3.95551 6.87955 4.05725 6.3914C4.159 5.90324 4.38082 5.44815 4.70265 5.06727C5.02448 4.68639 5.43618 4.39174 5.9005 4.20996",
    stroke: "#0017E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7L9.5 4.5",
    stroke: "#0017E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5L9.5 4.5L9 2.5L11 0.5L11.5 2.5L13.5 3L11.5 5Z",
    stroke: "#0017E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetIcon);
export default __webpack_public_path__ + "static/media/target_icon.14113bba28a2ca948b6f1f9f799d9b8f.svg";
export { ForwardRef as ReactComponent };